import { NumberInput, NumberInputProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormNumberInputProps<Values = Record<string, unknown>>
  extends NumberInputProps,
    IFocusableFormField<Values> {}

export const FormNumberInput: <Values = Record<string, unknown>>(
  props: IFormNumberInputProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, onChange, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  const inputProps = parentForm.getInputProps(fieldName);
  const inputOnChange = inputProps.onChange;
  inputProps.onChange = (value: any) =>
    inputOnChange(value === "" ? null : value);

  if (onChange) {
    const additionalOnChange = onChange;
    const existingInputOnChange = inputProps.onChange;
    inputProps.onChange = (e: any) => {
      additionalOnChange(e);
      return existingInputOnChange(e);
    };
  }
  if (!inputProps.value && inputProps.value !== 0) {
    inputProps.value = "";
  }
  return (
    <NumberInput type="number" {...inputProps} {...rest} ref={elementRef} />
  );
};
